module.exports = __webpack_public_path__ + "static/media/artificios_nao_recomendados.37314fd6.jpg";